module.exports = __webpack_public_path__ + "assets/img/meat_grubder.dd34a173.png";